module.exports = __webpack_public_path__ + "static/media/archive-dark5f933f12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/practice_admin/images/archive-dark.svg
// module id = 1509
// module chunks = 0